import useTranslation from "../../../client/hooks/useTranslation";
import { useLiteData } from "../../data/LiteDataProvider";
import type { LiteTrade } from "../../lib/types";
import type { Insight } from "../../ui/analytics";
import { Card, Empty } from "../../ui/ui";

export interface TabProps { trades: LiteTrade[] }

/** Rendu des constats traduits : `[[x]]` = chiffre en gras mono, `**x**` = gras. */
export function Rich({ text }: { text: string }) {
  const parts = text.split(/(\[\[.*?\]\]|\*\*.*?\*\*)/g).filter(Boolean);
  return (
    <>
      {parts.map((p, i) =>
        p.startsWith("[[") ? <b key={i} className="font-mono tabular-nums">{p.slice(2, -2)}</b>
        : p.startsWith("**") ? <b key={i}>{p.slice(2, -2)}</b>
        : <span key={i}>{p}</span>,
      )}
    </>
  );
}

export const insight = (tone: Insight["tone"], text: string): Insight => ({ tone, text: <Rich text={text} /> });

/** Garde les constats valides (les conditions fausses renvoient false). */
export const compact = (items: (Insight | false | null | undefined)[]) => items.filter(Boolean) as Insight[];

/** Profit factor affichable (∞ si aucune perte et valeur infinie). */
export function usePf() {
  const t = useTranslation().lite.stats;
  const { fmt } = useLiteData();
  return (v: number) => (Number.isFinite(v) ? fmt.num(v) : t.infinite);
}

/** Carte vide avec titre, pour une répartition sans données. */
export function EmptyCard({ title, subtitle, emptyTitle, emptyText, className = "" }: {
  title: string; subtitle?: string; emptyTitle: string; emptyText: string; className?: string;
}) {
  return (
    <Card title={title} subtitle={subtitle} className={className}>
      <Empty title={emptyTitle}>{emptyText}</Empty>
    </Card>
  );
}
